import {EQUITY, FUND, ETF, CEF} from 'src/Api';

export default function AssetClass({instrumentInfo}) {
    
    const getAssetClass = () => {
        switch (instrumentInfo.type) {
            case ETF:
                return ETF;                
        }
    }

    return <div className="card z-depth-0 margin-0">
        <div className="card-content padding-top-0-sm padding-right-0-sm padding-bottom-30-sm padding-left-0-sm padding-bottom-0" data-testid="assetClassValue">
            <h2 className="card-title" data-testid="assetClassHeader">Asset class</h2>
            {getAssetClass()}
            <hr />
        </div>
    </div>
}